import axios from 'axios';

const getRooms = async (query, referer, page, perPage) => {
    let data = {
        'client': GLOBAL.client,
        'query': query,
        'page': page,
        'perPage': perPage,
        'referer': referer,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/get-rooms.php',
            data
        )
        .then((d) => d.data)
}

export {
    getRooms
};